import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7c0f9a1e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "scroll-div"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ppc_sb_budget_allocation_header = _resolveComponent("ppc-sb-budget-allocation-header");
  const _component_ppc_sb_budget_allocation_item = _resolveComponent("ppc-sb-budget-allocation-item");
  const _component_app_card_custom = _resolveComponent("app-card-custom");
  return _openBlock(), _createBlock(_component_app_card_custom, {
    "no-padding": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_ppc_sb_budget_allocation_header, {
      mode: $data.mode,
      "onUpdate:mode": _cache[0] || (_cache[0] = $event => $data.mode = $event),
      search: $data.search,
      "onUpdate:search": _cache[1] || (_cache[1] = $event => $data.search = $event),
      items: $options.filteredItems,
      currency: $props.currency,
      still_initializing: $props.still_initializing
    }, null, 8, ["mode", "search", "items", "currency", "still_initializing"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredItems, (item, index) => {
      return _openBlock(), _createBlock(_component_ppc_sb_budget_allocation_item, {
        key: index,
        item: item,
        mode: $data.mode,
        currency: $props.currency,
        last: index === $options.filteredItems.length - 1,
        "weekly-budget-target": $data.weeklyBudgetTarget,
        selected_profile_id: $props.selected_profile_id,
        still_initializing: $props.still_initializing,
        onItemUpdate: $options.onItemUpdate,
        onWeeklyBudgetEdit: $options.onWeeklyBudgetEdit
      }, null, 8, ["item", "mode", "currency", "last", "weekly-budget-target", "selected_profile_id", "still_initializing", "onItemUpdate", "onWeeklyBudgetEdit"]);
    }), 128))]), _renderSlot(_ctx.$slots, "pagination", {}, undefined, true)]),
    _: 3
  });
}